<div class="container">
    <div class="profile-page__header">
      <div id="map" class="map" [class.title-placeholder]="loading"></div>
      <div class="body">
        <div class="img-with-chart" [class.active]="chartPopup">
          <img loading="lazy" class="profile-img" (click)="chartPopup = !chartPopup" [class.title-placeholder]="loading" src="{{ local.checkImageProfile(profile) }}" alt="" />
          <div class="my-chart">
            <canvas baseChart [data]="radarChartData" [options]="radarChartOptions" [type]="radarChartType"> </canvas>
          </div>
        </div>
        <div class="name" [class.title-placeholder]="loading">
          {{ profile.profileCharacterName }}
          <div>
            <span class="badge" *ngFor="let item of profile?.certified">
              {{ item }}
            </span>
          </div>
        </div>
        <div class="meta">
          <span class="item"> <i class="fa-regular fa-clock"></i>Since {{ createdString }} </span>
          <span class="item" > <i class="fa-regular fa-square-plus"></i>{{ profile.appUserSupports.length }} Support </span>
          <span class="item" *ngIf="profile?.region"> <i class="fa-solid fa-earth-asia"></i>{{ profile.region.split("|")[1] }} </span>
        </div>
        <div class="about">
          {{ profile.shortDescription }}
        </div>
    
        <div class="bottom">
          <div class="certificates">
            @if(profile?.certificates.length){
            <div class="certificates__title">Badge</div>
            <ng-container *ngFor="let role of profile?.certificates">
              <img loading="lazy" src="{{ certificateImgUrl }}{{ role.role }}.png" alt="" />
            </ng-container>
            }
          </div>
          <div class="right">
            <button (click)="handleSupportSeller()" class="button-2 mr-2" [class.active]="profile.isSupport" style="font-size: small;"><i  *ngIf="!profile.isSupport" class="fa-solid fa-plus"></i> {{ profile.isSupport ? "Supported" : "Support" }}</button>
            <span class="icon-list" aria-hidden="true" id="profileMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
              <i class="fa-solid fa-ellipsis-v"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    </div>